import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Outlet } from "react-router-dom";
import { smartTowerColors } from "@/themes/palette/tokens";

export default function LayoutAuth() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: `linear-gradient(135deg, ${smartTowerColors.blue800} 0%, ${smartTowerColors.blue500} 100%)`,
      }}
    >
      <CssBaseline />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          maxWidth: "600px",
          padding: "20px",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
